import type { TemplateFn } from "./index";
import { ROOT_TARGET, baseTimeline } from "./_helpers";

// Safe-default reveal. The "Apple-style" intro: 1s, soft Y rise, ends crisp.
export const fadeIn: TemplateFn = (ir, logo) => {
  const base = baseTimeline(ir, logo);
  return {
    ...base,
    tracks: [{
      target: ROOT_TARGET,
      easing: "easeOutExpo",
      delay: 0,
      keyframes: [
        { t: 0.00, opacity: 0, y: 14, scale: 0.985, filter: "blur(6px)" },
        { t: 0.70, opacity: 1, y: 0,  scale: 1,     filter: "blur(0px)" },
        { t: 1.00, opacity: 1, y: 0,  scale: 1,     filter: "blur(0px)" },
      ],
    }],
  };
};
